import { Tooltip } from '~/components';

interface GroupInfoProps {
  groups: string[];
}

export function GroupInfo({ groups }: GroupInfoProps) {
  if (!groups?.length) {
    return '-';
  }

  const [groupName, ...restGroups] = groups;

  return (
    <div>
      <span className="break-words">{groupName}</span>
      {groups.length > 1 ? (
        <Tooltip
          content={restGroups.join(', ')}
          side="top"
          delayDuration={0}
          contentClassName="max-h-[13rem] overflow-y-auto"
        >
          <span className="ml-md basis-md rounded-xs border px-sm py-xs text-center text-body-xs leading-5 bg-level-05 border-emphasis-subtle">
            +{restGroups.length}
          </span>
        </Tooltip>
      ) : null}
    </div>
  );
}

GroupInfo.displayName = 'GroupInfo';
